import _extends from "@babel/runtime/helpers/esm/extends";
import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M5.75 2c.411 0 4.166 5.895 3.671 6.346-1.64 1.505-1.387 1.798-1.387 1.798s.242.577 2.656 2.989l.176.176c2.412 2.414 2.989 2.656 2.989 2.656s.016.014.061.014c.145 0 .588-.148 1.737-1.401.027-.032.076-.045.142-.045 1.014 0 6.205 3.33 6.205 3.717 0 2.775-1.725 3.75-3.712 3.75-3.704-.023-6.288-1.953-10.25-5.843l-.198-.192C3.72 12 2.023 9.416 2 5.75 1.988 3.748 2.958 2 5.75 2z"
});

var SvgCallFilled = function SvgCallFilled(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgCallFilled;